import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import { z } from 'zod'

// Search Params Schema
export const Po1010SearchParamsSchema = z
  .object({
    number: z.string().optional(),
    refNo: z.string().optional(),
    fromDate: z.coerce.date().optional(),
    toDate: z.coerce.date().optional(),
    status: z.enum(['1', '2', '3', '4']).optional(),
  })
  .merge(BasePaginateParamsSchema)

export type Po1010SearchParams = z.infer<typeof Po1010SearchParamsSchema>

// Search Result Model Schema
export const Po1010SearchResultModelSchema = z.object({
  id: z.number(),
  number: z.string(),
  refNo: z.string().nullish(),
  date: z.coerce.date(),
  refDate: z.coerce.date().nullish(),
  dueDate: z.coerce.date(),
  remark: z.string().nullish(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]),
})

export type Po1010SearchResultModel = z.infer<
  typeof Po1010SearchResultModelSchema
>

// Search Result Schema
export const Po1010SearchResultSchema = z
  .object({
    data: z.array(Po1010SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Po1010SearchResult = z.infer<typeof Po1010SearchResultSchema>
